import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import Icon from '../../../components/Icon';
import Tab from '../../../components/Tab';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Button from '../../../components/Button';
import PropTypes from 'prop-types';

const messages = defineMessages({
  men: {
    id: 'athletics-gender-men',
    defaultMessage: 'Men',
  },
  women: {
    id: 'athletics-gender-women',
    defaultMessage: 'Women',
  },
  coed: {
    id: 'athletics-gender-coed',
    defaultMessage: 'Co-Ed',
  },
});

const genders = {
  COED: 'coed',
  FEMALE: 'women',
  MALE: 'men',
};

class Athletics extends React.PureComponent {
  static propTypes = {
    athletics: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.state = {
      gender: genders.MALE,
    };
  }

  onGenderChange(gender) {
    this.setState({ gender });
  }

  render() {
    const { athletics } = this.props;
    const { gender } = this.state;
    const windowWidth = window.innerWidth;

    const sortedAthletics = athletics.sort((a, b) => a.type.localeCompare(b.type));
    return (
      <Tab.Pane className="athletics-gender-container">
        <div
          className="athletics-gender-btn-container"
          data-cy="organizations-services-athletics-btn-container"
        >
          <Button
            data-cy="athletics-gender-men"
            aria-label="Men's Sports"
            className={`athletics-gender-btn ${
              gender === genders.MALE ? 'athletics-gender-selected' : ''
            }`}
            onClick={() => this.onGenderChange(genders.MALE)}
          >
            <FormattedMessage {...messages.men} />
          </Button>
          <Button
            data-cy="athletics-gender-women"
            aria-label="Women's Sports"
            className={`athletics-gender-btn ${
              gender === genders.FEMALE ? 'athletics-gender-selected' : ''
            }`}
            onClick={() => this.onGenderChange(genders.FEMALE)}
          >
            <FormattedMessage {...messages.women} />
          </Button>
          <Button
            data-cy="athletics-gender-coed"
            aria-label="Coed's Sports"
            className={`athletics-gender-btn ${
              gender === genders.COED ? 'athletics-gender-selected' : ''
            }`}
            onClick={() => this.onGenderChange(genders.COED)}
          >
            <FormattedMessage {...messages.coed} />
          </Button>
        </div>
        <Table
          striped="true"
          columns={7}
          unstackable="true"
          className="athletics-gender-table"
          data-cy="organizations-services-athletics-table"
        >
          <Thead>
            <Tr>
              <Th>{ /* istanbul ignore next */ windowWidth >= 768 ? '' : 'Sport'}</Th>
              <Th>Division</Th>
              <Th>Conference</Th>
              <Th>Association</Th>
              <Th>Varsity</Th>
              <Th>Club</Th>
              <Th>Intramural</Th>
            </Tr>
          </Thead>
          <Tbody>
            {sortedAthletics.map(sport => (
              <Tr key={sport.type} className="athletics-gender-table-tr">
                <Td className="athletics-gender-table-td">{sport.type}</Td>
                <Td className="athletics-gender-table-td">
                  {sport[gender].division.replace(/Division /i, '')}
                </Td>
                <Td className="athletics-gender-table-td">{sport[gender].conference}</Td>
                <Td className="athletics-gender-table-td">{sport[gender].association}</Td>
                <Td className="athletics-gender-table-td">
                  {sport[gender].association === '' ? (
                    <Icon name="x" color="red" size="large" />
                  ) : (
                    <Icon name="check" color="green" size="large" />
                  )}
                </Td>
                <Td className="athletics-gender-table-td">
                  {sport[gender].others.club ? (
                    <Icon name="check" color="green" size="large" />
                  ) : (
                    <Icon name="x" color="red" size="large" />
                  )}
                </Td>
                <Td className="athletics-gender-table-td">
                  {sport[gender].others.intramural ? (
                    <Icon name="check" color="green" size="large" />
                  ) : (
                    <Icon name="x" color="red" size="large" />
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Tab.Pane>
    );
  }
}

export default Athletics;
